import { render, staticRenderFns } from "./clientCard.vue?vue&type=template&id=30dd74f1&scoped=true"
import script from "./clientCard.vue?vue&type=script&lang=js"
export * from "./clientCard.vue?vue&type=script&lang=js"
import style0 from "./clientCard.vue?vue&type=style&index=0&id=30dd74f1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30dd74f1",
  null
  
)

export default component.exports